import React from "react";
import PageHeader from "../../components/PageHeader";
import AbandonOrdersListComponent from "../../components/AbandonOrders/AbandonOrdersListComponent";

class AbandonOrdersList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Abandon Orders"
                            Breadcrumb={[
                                { name: "Abandon Orders", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <AbandonOrdersListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AbandonOrdersList;
